import {
  INTERNAL_OPERATION_TYPES,
  TRANSACTION_TYPES,
  OPERATION_TYPES,
} from '@/shared/lib/utils/coinsConstants'
import {
  addBreadcrumbsBeforeApiRequest,
  captureApiError,
} from '@/shared/lib/captureApiError'
import { TOAST_DISPATCHERS } from '@/shared/constants/store-constants/toast'
import i18n from '@/app/i18n'

function initState() {
  return {
    // Transaction Types
    transactionTypes: TRANSACTION_TYPES,
    operationTypes: OPERATION_TYPES,
  }
}

const state = initState()

const mutations = {}

const actions = {
  HISTORY_USERS(
    { rootState, rootGetters },
    {
      accountTypeIds = [1, 7],
      coinId,
      limit,
      offset,
      date_from,
      date_to,
      typesId,
    }
  ) {
    return new Promise((resolve, reject) => {
      const filters = {
        coins_ids: coinId ? [coinId] : null,
        from: date_from,
        to: date_to,
        transaction_types_ids: typesId,
        account_type_ids: accountTypeIds,
        coinhold_id: null,
        type: 'wallet',
        coin_code: null,
      }

      this.$apiService()
        .post(
          `/history/users${
            rootGetters['auth/isSub']
              ? `?username=${rootState.auth.username}`
              : ''
          }`,
          {
            ...filters,
            limit,
            offset,
          }
        )
        .then((data) => {
          if (data.wallets) {
            const result = data.wallets
              ? data.wallets.map((i) => {
                  if (INTERNAL_OPERATION_TYPES.includes(i.type)) {
                    return {
                      ...i,
                      status: 2,
                    }
                  }
                  return i
                })
              : []
            resolve(data, {
              ...data,
              wallets: result,
            })
          } else {
            reject(data.error)
          }
        })
        .catch((e) => {
          console.error('HISTORY_USERS:', e)
          captureApiError('HISTORY_USERS', '/history/users', e)
          reject(e.response.data.error)
        })
    })
  },

  // Return array with all user addresses (in all networks) for the coin
  async GET_PROFILE_ADDRESS(
    { rootState, rootGetters, dispatch },
    { coin, networkId }
  ) {
    try {
      addBreadcrumbsBeforeApiRequest(
        'GET_PROFILE_ADDRESS',
        '/profile/address',
        {
          subAccountId: rootGetters['auth/isSub']
            ? `/${rootState.auth.accountID}`
            : '',
        }
      )
      const response = await this.$apiService().endpointApi.post(
        `/profile/address${
          rootGetters['auth/isSub'] ? `/${rootState.auth.accountID}` : ''
        }`,
        {
          coin_id: coin,
          network_id: networkId,
        }
      )
      // Return only addresses with the required coinId and networkId
      const filteredAddresses = response.filter(
        (item) => item.coin_id === coin && item.network_id === networkId
      )

      // Показываем тост если адреса не найдены
      if (filteredAddresses.length === 0) {
        dispatch(
          TOAST_DISPATCHERS.setErrorMessage,
          {
            title: i18n.global.t('ToastError | title'),
            message: i18n.global.t('ToastError | message'),
          },
          { root: true }
        )
      }

      return filteredAddresses
    } catch (error) {
      console.error('GET_PROFILE_ADDRESS:', { ...error })
      captureApiError('GET_PROFILE_ADDRESS', '/profile/address', error)

      // Показываем тост при ошибке API
      dispatch(
        TOAST_DISPATCHERS.setErrorMessage,
        {
          title: i18n.global.t('ToastError | title'),
          message: i18n.global.t('ToastError | message'),
        },
        { root: true }
      )

      return []
    }
  },
}

const getters = {
  walletsBalanceByCoin(state, getters, rootState) {
    return Object.values(rootState.coinService.coinBalances).reduce(
      (acc, cur) => ({
        ...acc,
        [cur.coin_id]:
          rootState.coinService.coinBalances[cur.coin_id].wallet_balance,
      }),
      {}
    )
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
